import { useLocation } from "react-router-dom";

export const useQueryStrings = () => {
  return new URLSearchParams(useLocation().search)
};